function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { loginObj } from '@/services/base';
import axios from 'axios';
import setupInterceptors from '@/services/setupInterceptors';
var configuration = JSON.parse(process.env.VUE_APP_API_GTW_CONFIG);
//console.log(configuration)
// declare service gtw
var appApisGTW = null;
if (!configuration['customer_insights']) {
  appApisGTW = axios.create({
    baseURL: 'http://localhost{PORT}'.replace('{PORT}', ':8091')
  });
} else {
  appApisGTW = axios.create({
    baseURL: process.env.VUE_APP_API_GTW.replace('{PORT}', ':8000')
  });
}
setupInterceptors(appApisGTW);
var MICROSERVICE = '/customer_insights';
var GROUP_NAME = '/somos1';
var DOMAIN_DATA_ENTRY = '/data_entry';
var CONTROLLER_REGION = '/region';
var CONTROLLER_BRAND = '/brand';
var CONTROLLER_ORGANIZATION = '/organization';
var CONTROLLER_INDICATOR = '/indicator';
var CONTROLLER_VISITOR = '/visitor';
var DOMAIN_BUDGET = '/budget';
export default {
  getDataEntryList: function getDataEntryList() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    return appApisGTW.post("".concat(MICROSERVICE).concat(GROUP_NAME).concat(DOMAIN_DATA_ENTRY, "/list"), body).then(function (response) {
      return response.data;
    });
  },
  getDataEntryCustomList: function getDataEntryCustomList(OrganizationId, BrandId, IndicatorId, RegionList) {
    var data = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    return appApisGTW.post("".concat(MICROSERVICE).concat(GROUP_NAME).concat(DOMAIN_DATA_ENTRY, "/").concat(OrganizationId, "/").concat(BrandId, "/").concat(IndicatorId, "/").concat(RegionList, "/list"), body).then(function (response) {
      return response.data;
    });
  },
  getRegionsList: function getRegionsList() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    return appApisGTW.post("".concat(MICROSERVICE).concat(GROUP_NAME).concat(DOMAIN_DATA_ENTRY).concat(CONTROLLER_REGION, "/list"), body).then(function (response) {
      return response.data;
    });
  },
  getOrganization: function getOrganization() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var company_code = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '0';
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    if (company_code === '0') {
      return appApisGTW.post("".concat(MICROSERVICE).concat(GROUP_NAME).concat(DOMAIN_DATA_ENTRY).concat(CONTROLLER_ORGANIZATION, "/info"), body).then(function (response) {
        return response.data;
      });
    } else {
      return appApisGTW.post("".concat(MICROSERVICE).concat(GROUP_NAME).concat(DOMAIN_DATA_ENTRY).concat(CONTROLLER_ORGANIZATION, "/").concat(company_code, "/info"), body).then(function (response) {
        return response.data;
      });
    }
  },
  getOrganizationsList: function getOrganizationsList() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    return appApisGTW.post("".concat(MICROSERVICE).concat(GROUP_NAME).concat(DOMAIN_DATA_ENTRY).concat(CONTROLLER_ORGANIZATION, "/list"), body).then(function (response) {
      return response.data;
    });
  },
  getBrandsList: function getBrandsList(OrganizationId) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    return appApisGTW.post("".concat(MICROSERVICE).concat(GROUP_NAME).concat(DOMAIN_DATA_ENTRY).concat(CONTROLLER_BRAND, "/").concat(OrganizationId, "/list"), body).then(function (response) {
      return response.data;
    });
  },
  getIndicatorsByOrganizationList: function getIndicatorsByOrganizationList(OrganizationDomain) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    return appApisGTW.post("".concat(MICROSERVICE).concat(GROUP_NAME).concat(DOMAIN_DATA_ENTRY).concat(CONTROLLER_INDICATOR, "/").concat(OrganizationDomain, "/listByDomain"), body).then(function (response) {
      return response.data;
    });
  },
  getOrganizationIndicatorsList: function getOrganizationIndicatorsList() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var company_code = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '0';
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    if (company_code === '0') {
      return appApisGTW.post("".concat(MICROSERVICE).concat(GROUP_NAME).concat(DOMAIN_DATA_ENTRY).concat(CONTROLLER_INDICATOR, "/ListByOrganization"), body).then(function (response) {
        return response.data;
      });
    } else {
      return appApisGTW.post("".concat(MICROSERVICE).concat(GROUP_NAME).concat(DOMAIN_DATA_ENTRY).concat(CONTROLLER_INDICATOR, "/").concat(company_code, "/ListByOrganization"), body).then(function (response) {
        return response.data;
      });
    }
  },
  getIndicatorsByOrganizationBrandList: function getIndicatorsByOrganizationBrandList(OrganizationId, BrandId) {
    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    return appApisGTW.post("".concat(MICROSERVICE).concat(GROUP_NAME).concat(DOMAIN_DATA_ENTRY).concat(CONTROLLER_INDICATOR, "/").concat(OrganizationId, "/").concat(BrandId, "/list"), body).then(function (response) {
      return response.data;
    });
  },
  getBudgetIndicatorsByOrganizationBrandList: function getBudgetIndicatorsByOrganizationBrandList(OrganizationId, BrandId) {
    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    return appApisGTW.post("".concat(MICROSERVICE).concat(GROUP_NAME).concat(DOMAIN_DATA_ENTRY).concat(CONTROLLER_INDICATOR, "/").concat(OrganizationId, "/").concat(BrandId, "/budgetList"), body).then(function (response) {
      return response.data;
    });
  },
  postDataEntryAll: function postDataEntryAll() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var company_code = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '0';
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    if (company_code === '0') {
      return appApisGTW.post("".concat(MICROSERVICE).concat(GROUP_NAME).concat(DOMAIN_DATA_ENTRY, "/all"), body).then(function (response) {
        return response.data;
      });
    } else {
      return appApisGTW.post("".concat(MICROSERVICE).concat(GROUP_NAME).concat(DOMAIN_DATA_ENTRY, "/").concat(company_code, "/all"), body).then(function (response) {
        return response.data;
      });
    }
  },
  postVerifyBulk: function postVerifyBulk() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var company_code = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '0';
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    if (company_code === '0') {
      return appApisGTW.post("".concat(MICROSERVICE).concat(GROUP_NAME).concat(DOMAIN_DATA_ENTRY, "/verify_bulk"), body).then(function (response) {
        return response.data;
      });
    } else {
      return appApisGTW.post("".concat(MICROSERVICE).concat(GROUP_NAME).concat(DOMAIN_DATA_ENTRY, "/").concat(company_code, "/verify_bulk"), body).then(function (response) {
        return response.data;
      });
    }
  },
  postDownloadData: function postDownloadData() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    return appApisGTW.post("".concat(MICROSERVICE).concat(GROUP_NAME).concat(DOMAIN_DATA_ENTRY, "/list_all"), body, {
      responseType: 'blob'
    }).then(function (response) {
      return response;
    });
  },
  postDownloadDataLog: function postDownloadDataLog() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    return appApisGTW.post("".concat(MICROSERVICE).concat(GROUP_NAME).concat(DOMAIN_DATA_ENTRY, "/list_all_with_user"), body, {
      responseType: 'blob'
    }).then(function (response) {
      return response;
    });
  },
  postDownloadDataByRegion: function postDownloadDataByRegion() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    return appApisGTW.post("".concat(MICROSERVICE).concat(GROUP_NAME).concat(DOMAIN_DATA_ENTRY, "/list_all_by_region"), body, {
      responseType: 'blob'
    }).then(function (response) {
      return response;
    });
  },
  getBudgetOrganizationIndicatorsList: function getBudgetOrganizationIndicatorsList() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var company_code = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '0';
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    if (company_code === '0') {
      return appApisGTW.post("".concat(MICROSERVICE).concat(GROUP_NAME).concat(DOMAIN_DATA_ENTRY).concat(CONTROLLER_INDICATOR, "/BudgetListByOrganization"), body).then(function (response) {
        return response.data;
      });
    } else {
      return appApisGTW.post("".concat(MICROSERVICE).concat(GROUP_NAME).concat(DOMAIN_DATA_ENTRY).concat(CONTROLLER_INDICATOR, "/").concat(company_code, "/BudgetListByOrganization"), body).then(function (response) {
        return response.data;
      });
    }
  },
  postVerifyBudgetGroup: function postVerifyBudgetGroup() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var company_code = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '0';
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    if (company_code === '0') {
      return appApisGTW.post("".concat(MICROSERVICE).concat(GROUP_NAME).concat(DOMAIN_BUDGET, "/verify_budget_group"), body).then(function (response) {
        return response.data;
      });
    } else {
      return appApisGTW.post("".concat(MICROSERVICE).concat(GROUP_NAME).concat(DOMAIN_BUDGET, "/").concat(company_code, "/verify_budget_group"), body).then(function (response) {
        return response.data;
      });
    }
  },
  postBudgetAll: function postBudgetAll() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var company_code = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '0';
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    if (company_code === '0') {
      return appApisGTW.post("".concat(MICROSERVICE).concat(GROUP_NAME).concat(DOMAIN_BUDGET, "/all"), body).then(function (response) {
        return response.data;
      });
    } else {
      return appApisGTW.post("".concat(MICROSERVICE).concat(GROUP_NAME).concat(DOMAIN_BUDGET, "/").concat(company_code, "/all"), body).then(function (response) {
        return response.data;
      });
    }
  },
  getBudgetCustomList: function getBudgetCustomList(OrganizationId, BrandId, IndicatorId, RegionList, ProjectionCategoryId) {
    var data = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    return appApisGTW.post("".concat(MICROSERVICE).concat(GROUP_NAME).concat(DOMAIN_BUDGET, "/").concat(OrganizationId, "/").concat(BrandId, "/").concat(IndicatorId, "/").concat(RegionList, "/").concat(ProjectionCategoryId, "/list"), body).then(function (response) {
      return response.data;
    });
  },
  postVerifyVisitor: function postVerifyVisitor() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    return appApisGTW.post("".concat(MICROSERVICE).concat(GROUP_NAME).concat(CONTROLLER_VISITOR, "/verify"), body).then(function (response) {
      return response.data;
    });
  },
  postCreateVisitorPresentation: function postCreateVisitorPresentation() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    return appApisGTW.post("".concat(MICROSERVICE).concat(GROUP_NAME).concat(CONTROLLER_VISITOR, "/create"), body).then(function (response) {
      return response.data;
    });
  },
  postVerifyVisitorPresentation: function postVerifyVisitorPresentation() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    return appApisGTW.post("".concat(MICROSERVICE).concat(GROUP_NAME).concat(CONTROLLER_VISITOR, "/verify"), body).then(function (response) {
      return response.data;
    });
  },
  postLastUpdate: function postLastUpdate() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    return appApisGTW.post("".concat(MICROSERVICE).concat(GROUP_NAME).concat(DOMAIN_DATA_ENTRY, "/verify_last_update"), body).then(function (response) {
      return response.data;
    });
  },
  postTracking: function postTracking() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    return appApisGTW.post("".concat(MICROSERVICE).concat(GROUP_NAME).concat(DOMAIN_DATA_ENTRY, "/tracking"), body).then(function (response) {
      return response.data;
    });
  },
  postTrackingByOrgYearMonth: function postTrackingByOrgYearMonth() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    return appApisGTW.post("".concat(MICROSERVICE).concat(GROUP_NAME).concat(DOMAIN_DATA_ENTRY, "/tracking_by_org_year_month"), body).then(function (response) {
      return response.data;
    });
  }
};